import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ReleaseScheduleInsertRequest } from "./ReleaseScheduleInsertRequest";
import { ReleaseScheduleUpdateRequest } from "./ReleaseScheduleUpdateRequest";

@Injectable()
export class DataService_StudentRelease {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	ReleaseScheduleSelectList(StartDate, EndDate, PersonID, SchoolID) {
		var postResult$ = new Subject();
		var url = "Release/ReleaseScheduleSelectList?StartDate=" + StartDate + "&EndDate=" + EndDate + "&PersonID=" + PersonID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReleaseTypeSelectList() {
		var postResult$ = new Subject();
		var url = "Release/ReleaseTypeSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExcuseSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Release/ExcuseSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReleaseScheduleInsert(parms: ReleaseScheduleInsertRequest) {
		var postResult$ = new Subject();
		var url = "Release/ReleaseScheduleInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GuardianFullInfoGetList(PersonID) {
		var postResult$ = new Subject();
		var url = "Release/GuardianFullInfoGetList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReleaseScheduleUpdate(parms: ReleaseScheduleUpdateRequest) {
		var postResult$ = new Subject();
		var url = "Release/ReleaseScheduleUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ReleaseScheduleDelete(ReleaseScheduleID) {
		var postResult$ = new Subject();
		var url = "Release/ReleaseScheduleDelete?ReleaseScheduleID=" + ReleaseScheduleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
